<template>
  <v-card elevation="0">
    <v-card-text class="d-flex align-center">
      <v-divider/>
      <div class="mx-2 text-h6 font-weight-light">
        Базовая часть
      </div>
      <v-divider/>
    </v-card-text>
    <path-table-eff-contract
      :is-date="isDate"
      :is-review="isReview"
      :list-contracts="currentPersonBasicListContracts"
      @open-auto-calculate-dialog="openAutoCalculateDialog"
      @openDialog="openDialogBasic"
      @editDialog="editDialogBasic"
      @deletePersonEffContract="deletePersonEffContract"
    />
    <div v-show="showStimulatingTable">
      <v-card-text class="d-flex align-center">
        <v-divider/>
        <div class="mx-2 text-h6 font-weight-light">
          Стимулирующая часть
        </div>
        <v-divider/>
      </v-card-text>
      <path-table-eff-contract
        :is-date="isDate"
        :is-review="isReview"
        :list-contracts="currentPersonStimulatingListContracts"
        @openDialog="openDialogStimulating"
        @editDialog="editDialogStimulating"
        @open-auto-calculate-dialog="openAutoCalculateDialog"
        @deletePersonEffContract="deletePersonEffContract"
      />
    </div>
  </v-card>
</template>

<script>


import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import {createHelpers} from "vuex-map-fields";
import PathTableEffContract from "./PathTableEffContract.vue";
import CheckServices from "../../../services/CheckContract.services";

const {mapFields} = createHelpers({
  getterType: 'effective_contract/getPayloadPersonContract',
  mutationType: 'effective_contract/updatePayloadPersonContract',
});


export default {
  name: "eff-con-table",

  components: {
    PathTableEffContract,
  },

  props: {
    check_button: {
      Type: Boolean,
      default: true
    },

    typeBasicContract: {
      type: String,
      validator: function (value) {
        return [
          'bidBasic',
          'deanBasic',
          "headDepartmentBasic"].includes(value)
      },
    },

    typeStimulatingContract: {
      type: String,
      validator: function (value) {
        return [
          'bidStimulating',
          "deanStimulating",
          "headDepartmentStimulating"].includes(value)
      },
    },

  },

  data() {
    return {
      page: 1,
      itemsPerPage: 15,
      search: "",
      refreshData: false,
      headers: [
        {
          text: 'Наименование показателя',
          value: 'eff_contract.indicator_name',
          groupable: false,
          divider: true,
          sortable: false,
          width: '35%',
        },
        {
          text: 'Ед. измерения',
          value: 'eff_contract.units_measurement',
          groupable: false,
          sortable: false,
          width: "5%",
        },
        {
          text: 'План', value: 'eff_contract.plan', groupable: false, sortable: false, width: '10%',
        },
        {
          text: 'Факт', value: 'fact', groupable: false, sortable: false, width: '10%',
        },
        {
          text: 'Файл', value: 'file', groupable: false, sortable: false, width: '35%', divider: true,
        },
        {
          text: 'Действия', value: 'actions', sortable: false, width: '5%',
        },
      ],
    };
  },

  watch: {
    async showStimulatingTable() {
      if (this.showStimulatingTable && this.currentPersonStimulatingListContracts.length === 0) {
        this.autoCalculateFactsAction();
      }
    }
  },

  computed: {

    ...mapFields([
      'fact',
      'author',
      'eff_contract_id',
      'file',
      'link_source',
    ]),

    isDate() {
      return CheckServices.checkDate();
    },

    ...mapState({
      isReview: state => state.effective_contract.payloadOrder.is_sent_review,
    }),

    ...mapGetters({
      listPersonBasicBidContract: "effective_contract/listPersonBasicBidContract",
      listPersonStimulatingBidContract: "effective_contract/listPersonStimulatingBidContract",
      listPersonBasicDeanContract: "effective_contract/listPersonBasicDeanContract",
      listPersonStimulatingDeanContract: "effective_contract/listPersonStimulatingDeanContract",
      listPersonBasicHeadDepartmentContract: "effective_contract/listPersonBasicHeadDepartmentContract",
      listPersonStimulatingHeadDepartmentContract: "effective_contract/listPersonStimulatingHeadDepartmentContract",

      checkBasicBid: "effective_contract/checkBasicBid",
      checkBasicHeadDepartment: "effective_contract/checkBasicHeadDepartment",
      checkBasicDean: "effective_contract/checkBasicDean",
    }),

    numberOfPages() {
      return Math.ceil(this.rating.length / this.itemsPerPage)
    },

    currentPersonBasicListContracts() {
      switch (this.typeBasicContract) {
        case "bidBasic":
          return this.listPersonBasicBidContract;
        case "deanBasic":
          return this.listPersonBasicDeanContract;
        case "headDepartmentBasic":
          return this.listPersonBasicHeadDepartmentContract;
        default:
          return [];
      }
    },

    currentPersonStimulatingListContracts() {
      switch (this.typeStimulatingContract) {
        case "bidStimulating":
          return this.listPersonStimulatingBidContract;
        case "deanStimulating":
          return this.listPersonStimulatingDeanContract;
        case "headDepartmentStimulating":
          return this.listPersonStimulatingHeadDepartmentContract;
        default:
          return [];
      }
    },

    showStimulatingTable() {
      switch (this.typeBasicContract) {
        case "bidBasic":
          return this.checkBasicBid.length === 0;
        case "deanBasic":
          return this.checkBasicDean.length === 0;
        case "headDepartmentBasic":
          return this.checkBasicHeadDepartment.length === 0;
        default:
          return false;
      }
    }

  },
  methods: {
    ...mapActions({
      setDialogAction: 'effective_contract/setDialogAction',
      deletePersonEffContract: "effective_contract/deletePersonEffContract",
      autoCalculateFactsAction: "effective_contract/autoCalculateFactsAction",
    }),

    ...mapMutations({
      setTypeDialogContract: "effective_contract/setTypeDialogContract",
      setEditPayloadPersonContract: "effective_contract/setEditPayloadPersonContract",
      setIsEditDialog: "effective_contract/setIsEditDialog",
    }),

    openDialogBasic() {
      this.setTypeDialogContract(this.typeBasicContract);
      this.setDialogAction(true);
    },

    openDialogStimulating() {
      this.setTypeDialogContract(this.typeStimulatingContract);
      this.setDialogAction(true);
    },

    editDialogBasic(contract) {
      this.setTypeDialogContract(this.typeBasicContract);
      this.setEditPayloadPersonContract(contract);
      this.setIsEditDialog(true);
      this.setDialogAction(true);
    },

    editDialogStimulating(contract) {
      this.setTypeDialogContract(this.typeStimulatingContract);
      this.setEditPayloadPersonContract(contract);
      this.setIsEditDialog(true);
      this.setDialogAction(true);
    },

    openAutoCalculateDialog(id) {
      this.$emit("open-auto-calculate-dialog", id);
    },

  }
}
</script>

<style scoped>

</style>